import { render } from "./NewTask.vue?vue&type=template&id=8d4c62b4"
import script from "./NewTask.vue?vue&type=script&lang=js"
export * from "./NewTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__